export const GET_ALL_FILAS = 'GET_ALL_FILAS'
